module.exports = __webpack_public_path__ + "assets/0257e0a84fddaf50de799aa5d057dcb9.png";